import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { ROUTE_PATH, reportAssests, reportRoutes } from 'common/constants/sm-constants';
import { ReportsNavigationDataService } from 'common/services/data-services/admin/reports/reports-navigation.service';
import { ReportsNavigationModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-data-model';
import { ReportsNavigationListingModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-grid-model';
import { ReportsCardMetaModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-meta-model';
 
@Injectable({
    providedIn: 'root'
})
export class ReportsNavigationWidgetService extends GridWidgetService<ReportsNavigationModel, ReportsNavigationListingModel> {
    constructor(protected override ds: ReportsNavigationDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new ReportsCardMetaModel('Results', ROUTE_PATH.help, 4).getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: any, metaModel: ReportsCardMetaModel, routeData: WidgetModel): Promise<ReportsCardMetaModel> {
        return new Promise<ReportsCardMetaModel>((resolve, reject) => {
            dataModel?.filterModel.forEach((reportType: any) => {
                console.log(reportType);
                reportType['icon'] = reportAssests[reportType.type.toLowerCase()];
                reportType['id'] = parseInt(reportType.id);
                reportType['typeFlag'] = parseInt(reportType.typeFlag);
                reportType['orderNumber'] = parseInt(reportType.orderNumber);
                reportType['is_delete'] = parseInt(reportType.is_delete);
                reportType['routeUrl'] = reportRoutes[reportType.type.toLowerCase()];
                reportType['show'] = true;
            })
            metaModel.properties.cardItems = dataModel?.filterModel;
            resolve(metaModel);
        });
        
    }
}